export default "__VITE_ASSET__a30d24ba__"